import { createFileRoute } from "@tanstack/react-router";
import { zodValidator } from "@tanstack/zod-adapter";

import { EquipmentTableFilterSchema } from "./_list/-zod-schema";

export const Route = createFileRoute("/_staff/equipment/_layout/")({
  validateSearch: zodValidator(EquipmentTableFilterSchema),
});
